import { pluraliseUnit } from "/imports/libs/format";

export function formatDate(iso) {
  if (!iso) return "";
  try {
    return new Date(iso).toLocaleDateString(undefined, { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
}

// Identifies one purchasable variant row. Booking views that advertise a pack
// deep-link with this key so Plans can scroll to the exact row they promised.
export function variantRowKey(pkg, opt) {
  return `${pkg._id}:${opt.variantKey || opt.pricingId}`;
}

// Same key for a package offer, which arrives flat from the offers endpoint
// rather than as a (package, option) pair.
export function offerRowKey(offer) {
  return `${offer.productId}:${offer.variantKey || offer.pricingId}`;
}

export function formatExpiry(opt) {
  if (opt.noExpiry) return "No expiry";
  if (opt.expiryDuration && opt.expiryDurationUnit) return `${opt.expiryDuration} ${pluraliseUnit(opt.expiryDuration, opt.expiryDurationUnit)}`;
  return null;
}

export function formatMembershipDuration(opt) {
  if (opt.noExpiry) return "No expiry";
  if (opt.duration && opt.durationUnit) return `${opt.duration} ${pluraliseUnit(opt.duration, opt.durationUnit)}`;
  return null;
}

// Resolve an entity's locationIds to a readable label. When it covers every
// location the widget serves, collapse to "All locations".
export function locationLabelFor(entity, locations, locById) {
  const names = (entity.locationIds || []).map((id) => locById.get(id)?.name).filter(Boolean);
  if (names.length === 0) return null;
  if (names.length === (locations || []).length) return "All locations";
  return names.join(" · ");
}
